import { getStorebrandClient } from "Api/clients/storebrand";
import { createRequest } from "Utils/requestUtils";
import { DetailedVehicle, Vehicle } from ".";

const carUri = "/insurance/vehicles";
export const fetchCurrentUsersVehicles = async (): Promise<Vehicle[]> => {
  const client = await getStorebrandClient();
  const { data } = await client.get<Vehicle[]>(carUri);
  return data;
};

const registrationUri = "/insurance/vehicle";
export const fetchVehicle = async (
  registrationNumber: string,
): Promise<DetailedVehicle> => {
  const { data } = await createRequest({
    method: "get",
    url: `${registrationUri}/${registrationNumber}`,
    open: false,
  });

  return data;
};
